import { merge } from 'lodash-es'

import type { AppFile } from '@lib/types/app'
import { FileTypeEnum } from '@openapi'
import useCanvas from '@lib/apps/canvas-builder/composables/useCanvas'

export const loadCanvasAndDsrApps = async (): Promise<AppFile[]> => {
  const { listFiles } = useCanvas()

  const filesList = (await listFiles.value?.({
    filters: { type: [FileTypeEnum.APP] },
  })) as AppFile[]

  return filesList
    .filter((a) => a.app_metadata?.module?.canvas?.enabled || a.app_metadata?.module?.dsr?.enabled)
    .sort((a, b) =>
      (a.app_metadata?.display_name?.toLowerCase() ?? '').localeCompare(
        b.app_metadata?.display_name?.toLowerCase() ?? '',
      ),
    )
}

export const loadCrmShapeFromApps = async (): Promise<Record<string, any>> => {
  const { listFiles } = useCanvas()

  const filesList = (await listFiles.value?.({
    filters: { type: [FileTypeEnum.APP] },
  })) as AppFile[]

  return (
    filesList
      .filter((a) => a?.app_metadata?.provide?.includes('crm_shape'))
      .reduce<Record<string, any>>((acc, app) => merge(acc, app.metadata?.crm_shape ?? {}), {}) ?? {}
  )
}
